import shareType from '../../constants-v2/crm/share-type';
import personFullName from '../../filters/person/person-full-name';
import { moneyFormatToSting } from '../../helpers/MoneyHelpers';
import routeName from '../../routes/route-name';
import column from '../abstract/column';
import vars from '../abstract/vars';
import actions from './actions/index.js';
import api, { modelName } from './api';

export default {
  actions,
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100,
    }),
  },
  columns: {
    name: column({ label: 'Imię', format: item => item?.crm?.client?.person?.name }),
    surname: column({ label: 'Nazwisko', format: item => item?.crm?.client?.person?.surname }),
    phone: column({ label: 'Telefon', format: item => item?.crm?.client?.person?.company?.phone }),
    email: column({ label: 'E-mail', format: item => item?.crm?.client?.person?.login_email }),
    shares: column({
      label: 'Posiadane udziały',
      component: 'value-status-tooltips',
      items: ({ item }) => item?.share?.map(e => ({
        label: `${ moneyFormatToSting(e.value) }${ shareType.PERCENTAGE === e.sharetype ? ' %' : '' }`,
        tooltip: `Od: ${ e.valid_from || '-' } / Do: ${ e.valid_to || '-' }`,
      })),
    }),
  },
  vars: vars({
    noItemsText: 'Brak udziałowców',
    sidebarLabel: 'Podgląd udziałowca',
    softDelete: {
      title: 'Usunięcie udziałowca',
      text: (item) => `Czy na pewno chcesz usunąć udziałowca ${ personFullName(item?.crm?.client?.person) }?`,
      successText: 'Udziałowiec został usunięty.',
    },
  }),
  topRightActions: {
    create: {
      label: 'Dodaj udziałowca',
      icon: 'icon-plus',
      handle: async ({ $router }) => await $router.push({ name: routeName.partnerStaff.store }),
    },
  },
};
